import Axios from '../axios'
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import { logError } from '../../../shared'
import appConfig from '../../../app.config'

export interface Asset {
	assetType: string
	assetId: string
	name: string
	institution: string
	note: string
	value: number
	currency: string
	iban: string
	bic: string
}

export async function getAssetsService(customerId: string) {
	return Axios.get<Asset[]>(
		`${appConfig.customerDataBaseUrl}/api/deposit/assets/${customerId}`,
		await getHeadersWithJwtToken(),
	)
		.then(({ data }) => data)
		.catch((err) => {
			logError(err)
			throw err
		})
}
